import { pageDataService } from 'common/utilities/PageDataService';
import {
  AppLinksSettings,
  DeviceHealthState,
  DevicesSummary,
  DeviceSummary,
  ScanResults,
  SortOrder,
} from 'generated/clients/TypeScript/MicrosoftConsumerSecurityClient/v1/src/models';

// i18next-extract-mark-ns-start devices
export function getDeviceHealthStateString(
  t: any, // eslint-disable-line @typescript-eslint/no-explicit-any
  deviceHealthStatus: DeviceHealthState | undefined,
  deviceCount: number | undefined
): string {
  let statusString = t('Statuses.Unknown');

  switch (deviceHealthStatus) {
    case 'Protected':
      // TODO: remove following comment hint when i18next-extract supports i18next JSON v4
      // i18next-extract-disable-next-line
      statusString = t('Statuses.Protected', { count: deviceCount });
      break;
    case 'NeedsAttention':
      // TODO: remove following comment hint when i18next-extract supports i18next JSON v4
      // i18next-extract-disable-next-line
      statusString = t('Statuses.NeedsAttention', { count: deviceCount });
      break;
    case 'NotFullyProtected':
      statusString = t('Statuses.NotFullyProtected');
      break;
    case 'ActionRecommended':
      // TODO: remove following comment hint when i18next-extract supports i18next JSON v4
      // i18next-extract-disable-next-line
      statusString = t('Statuses.ActionRecommended', { count: deviceCount });
      break;
    case 'Unknown':
    default:
      break;
  }

  return statusString;
}

// Text that is displayed below the status text in certain circumstances
export function getDeviceHealthHelperText(
  t: any, // eslint-disable-line @typescript-eslint/no-explicit-any
  deviceHealthStatus: DeviceHealthState | undefined
): string | undefined {
  let helperText;

  switch (deviceHealthStatus) {
    case 'NeedsAttention':
      helperText = t('Statuses.HelperText.NeedsAttention');
      break;
    default:
      break;
  }

  return helperText;
}

export const getDevicesCount = (devicesSummary: DevicesSummary) =>
  devicesSummary.overallDevicesStatus?.unhealthyDevices === 0
    ? devicesSummary.overallDevicesStatus?.totalDevices
    : devicesSummary.overallDevicesStatus?.unhealthyDevices;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getDeviceCountString(t: any, devicesSummary: DevicesSummary): string {
  const deviceCount = getDevicesCount(devicesSummary);

  const showDeviceName = devicesSummary.overallDevicesStatus?.totalDevices === 1;

  // TODO: remove following comment hint when i18next-extract supports i18next JSON v4
  // i18next-extract-disable-next-line
  const deviceCountString = showDeviceName ? devicesSummary?.devices![0].name : t('DeviceWithCount', { count: deviceCount });

  return deviceCountString;
}

export function getFilesScannedString(scanResult?: ScanResults): string {
  return scanResult?.filesScanned?.toString() ?? '0';
}

export function getThreatsCountString(scanResult?: ScanResults): string {
  return scanResult?.threatsFound?.length.toString() ?? '0';
}

export function sortDevicesSummaryByDateTime(order: SortOrder, devices: DeviceSummary[]): DeviceSummary[] {
  const compareDateAsc = (device1: DeviceSummary, device2: DeviceSummary) => {
    const device1Date = device1.lastReportedDateTime!.getTime();
    const device2Date = device2.lastReportedDateTime!.getTime();
    return device1Date < device2Date ? -1 : 1;
  };
  const compareDateDesc = (device1: DeviceSummary, device2: DeviceSummary) => {
    const device1Date = device1.lastReportedDateTime!.getTime();
    const device2Date = device2.lastReportedDateTime!.getTime();
    return device1Date > device2Date ? -1 : 1;
  };

  return devices?.slice().sort(order === 'Desc' ? compareDateDesc : compareDateAsc);
}

// i18next-extract-mark-ns-stop devices
export function getDownloadLink(): string | undefined {
  const downloadSetting: AppLinksSettings = pageDataService.getDownloadLinks();
  return downloadSetting.link;
}

export function getQRImageLink(): string | undefined {
  return pageDataService.getDownloadLinks().qrLink;
}
